import { Fragment, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { Button, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import FilePageService from '../../API/FilePage/FilePageService';

const AddInsurerProduct = (props) => {
    const { t } = useTranslation();
    const { id } = useParams();

    const { showmodal, handleModalClose, handleAddNoteModalCloseAfterAPICall } = props;

    const [formData, setFormData] = useState({
        name: "",
        risk_type: "",
        guarantee: "",
        description: "",
    });

    const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (flashMessage.message) {
            const timer = setTimeout(() => {
                setFlashMessage({ type: "", message: "" });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [flashMessage]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const AddProduct = async (e) => {
        e.preventDefault();
        if (loading) return;

        if (!formData.name || !formData.risk_type || !formData.guarantee || !formData.description) {
            setFlashMessage({ type: "error", message: t("requriedErrorMessageLabel") });
            return;
        }

        setLoading(true);

        const payload = {
            ...formData,
            user_document_id: id,
        };

        try {
            const response = await FilePageService.insurer_product_create(payload);
            if (response.data.status) {
                setLoading(false);
                setFormData({ name: "", risk_type: "", guarantee: "", description: "" });
                handleAddNoteModalCloseAfterAPICall();
            } else {
                setLoading(false);
                setFlashMessage({
                    type: "error",
                    message: response.data.message || t("somethingWentWrong"),
                });
            }
        } catch (error) {
            setLoading(false);
            setFlashMessage({
                type: "error",
                message: error.response?.data?.message || t("somethingWentWrong"),
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Modal className='missing-doc-modal invalid-doc-modal' show={showmodal} onHide={handleModalClose}>
                <Form onSubmit={AddProduct}>
                    <Modal.Header closeButton>
                        <Modal.Title>Ajouter un produit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h2>Ajouter un produit</h2>

                        {flashMessage.message && (
                            <div
                                className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                                    ? "alert-success"
                                    : "alert-danger"
                                    } text-center`}
                                role="alert"
                            >
                                {flashMessage.message}
                            </div>
                        )}

                        <div className="mt-3">
                            <Form.Group className="mb-3">
                                <Form.Label>Nom du produit</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Nom du produit"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Type de risque</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="risk_type"
                                    value={formData.risk_type}
                                    onChange={handleChange}
                                    placeholder="Type de risque"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Garantie</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="guarantee"
                                    value={formData.guarantee}
                                    onChange={handleChange}
                                    placeholder="Garantie"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Tapez ici..."
                                />
                            </Form.Group>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="cancel-btn" variant="primary" onClick={handleModalClose}>
                            {t("cancelLabel")}
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            Ajouter
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default AddInsurerProduct;
